<script>
// import "@/assets/css/index.css";
import "@/assets/css/swiper.min.css";

import {Swiper, SwiperSlide} from 'swiper/vue';
import SwiperCore from "swiper"
import {Autoplay} from "swiper/modules";

SwiperCore.use([Autoplay])
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      banners: [require("@/assets/uploads/project.jpg")]
    }
  },
}

</script>

<template>

  <div id="main_body">

    <header class="main_header">
      <div class="header-wrapper">
        <div class="inner">

          <div class="title-block container ev-align--flex-center-v ev-flex--justify-space-between ev-flex--wrap" style="min-height:42px;">
            <div class="title-block__main">
              <h5 class="title-page">
                <span class="title-header">项目效果</span>
              </h5>
            </div>
          </div>

          <div class="banner" style="background-image: url('https://www.greendesign.com.au/wp-content/uploads/2018/01/banner-design-resources.jpg')">
            <img width="1884" height="1062" src="https://www.greendesign.com.au/wp-content/uploads/2018/01/banner-design-resources.jpg" class="attachment-full size-full">
          </div>
        </div>
      </div>
    </header>

    <div id="primary" class="content-area">
      <main id="content" class="site-content">
        <div class="main_content">
          <div class="container-full">
            <div class="swiper-container" style="width:80%;">
              <Swiper :loop="true" :autoplay="{ delay:4000 }" :navigation="true" :pagination="true" >
                <SwiperSlide v-for="banner in banners">
                  <div class="swiper-slide">
                    <img :src="banner" alt="">
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>

  <div>&nbsp;</div>

</template>
